module.exports = __webpack_public_path__ + "static/media/vacasa-logo-blue.6a8caa22.svg";